
import { fns, libTypes } from "@holta/lib";
import { useStore } from "../../config/store";
import { getEditOrder } from "./getEditOrder";
import {create} from 'mutative';

export const setDrawerbox = (drawerbox: libTypes.Order['drawerbox']) => {

    const editOrder = getEditOrder();

    useStore.setState({
        editOrder : create(editOrder, draft => {
            draft.newValues.order.drawerbox = fns.order.set.drawerbox(drawerbox);
        })
    });
};